import React from 'react'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import 'normalize.css'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import ApiWithContext from './components/apiWithContext'
import { AssetsProvider } from './components/assets'
import theme from './design'
import './design/index.scss'
import Router from './packages/routes'
import Handle from './prix/react/components/handle'
import serverlessSource from './prix/sources/serverless'
import { clearOutdatedOnly } from './prix/utils/browserCache'
import { auth } from './utils/client/auth'
import initErrorReporting from './utils/client/errorReporting'
import { apiBasePath, isDevelopment } from './utils/shared/platform'

initErrorReporting()

// @TODO: Remove this
;(window as any).createUserWithEmailAndPassword = (email: string, password: string) =>
  createUserWithEmailAndPassword(auth, email, password)

const sources = {
  default: serverlessSource({
    baseUrl: apiBasePath,
  }),
}

// Render

const appElement = document.getElementById('app')
const app = createRoot(appElement!)
app.render(
  <ThemeProvider theme={theme}>
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <Handle error={error} onTryAgain={resetErrorBoundary} />
      )}
      onReset={window.location.reload}
    >
      <AssetsProvider>
        <ApiWithContext sources={sources}>
          <Router />
        </ApiWithContext>
      </AssetsProvider>
    </ErrorBoundary>
    <ToastContainer />
  </ThemeProvider>,
)

// Service worker
async function prepareServiceWorker() {
  if ('serviceWorker' in navigator) {
    if (isDevelopment) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(registration => registration.unregister()))
      return
    }

    const { Workbox } = await import('workbox-window')
    const workbox = new Workbox('/sw.js')

    let shouldReloadOnControlling = false

    workbox.addEventListener('installed', event => {
      // First install: no reload. Updates: reload when it takes control.
      if (event.isUpdate) {
        shouldReloadOnControlling = true
      }
    })

    // Some older SW versions may still enter "waiting" (e.g. if they didn't skipWaiting).
    workbox.addEventListener('waiting', () => {
      shouldReloadOnControlling = true
      workbox.messageSkipWaiting()
    })

    workbox.addEventListener('controlling', () => {
      if (shouldReloadOnControlling) {
        window.location.reload()
      }
    })

    await workbox.register()

    // Force periodic update checks to reduce "next day" SW updates.
    setTimeout(() => workbox.update().catch(() => null), 30_000)
    window.addEventListener('focus', () => workbox.update().catch(() => null))
  }
}
prepareServiceWorker().catch(error => console.error(error))

// Clear outdated cache
setTimeout(() => {
  clearOutdatedOnly().catch(error => console.error(error))
}, 30000)

console.info(isDevelopment ? 'Development mode' : 'Production mode')
